"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureNames = void 0;
var Api_1 = require("./Api");
var localdatastore_1 = require("../config/localdatastore");
var StateProvider_1 = require("./StateProvider");
var Events_1 = require("./Events");
var FeatureService = /** @class */ (function () {
    function FeatureService() {
        this.FEATURE_TOGGLE = 'featureToggles';
        this.api = new Api_1.default();
        this.events = new Events_1.default([FeatureService.name]);
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        this.features = this.stateManager.get(localdatastore_1.getNamespace('CART'), this.FEATURE_TOGGLE);
        this.getFeatures = this.getFeatures.bind(this);
        if (!this.features) {
            this.getFeatures();
        }
    }
    FeatureService.getInstance = function () {
        if (!FeatureService.instance) {
            FeatureService.instance = new FeatureService();
        }
        return FeatureService.instance;
    };
    FeatureService.prototype.getFeatureStatus = function (featureName) {
        if (this.features && this.features.allocations && this.features.allocations[featureName]) {
            return true;
        }
        return false;
    };
    FeatureService.prototype.getFeatureStatusValue = function (featureName) {
        if (this.features && this.features.allocations && this.features.allocations[featureName] &&
            this.features.allocations[featureName].value === 'true') {
            return true;
        }
        return false;
    };
    FeatureService.prototype.getFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.features) {
                    return [2 /*return*/, this.api.getFeatures().then(function (response) {
                            if (response && response.allocations) {
                                _this.stateManager.set(_this.FEATURE_TOGGLE, response);
                                _this.features = response;
                            }
                            else {
                                console.info('FeatureService:::No Feature is Enabled!!!');
                            }
                            console.log('FeatureService response received');
                            _this.events.fireEvent({}, FeatureService.name);
                        }).catch(function (error) {
                            _this.events.fireEvent({}, FeatureService.name);
                        })];
                }
                else {
                    return [2 /*return*/, this.events.fireEvent({}, FeatureService.name)];
                }
                return [2 /*return*/];
            });
        });
    };
    return FeatureService;
}());
exports.default = FeatureService;
var FeatureNames;
(function (FeatureNames) {
    FeatureNames["TECHTRACKER_INSTALLATION"] = "svc-checkout-enable-techtracker";
    FeatureNames["TECHTRACKER_THANKYOU"] = "svc-enable-thankyou-techtracker";
    FeatureNames["APPLE_PAY_TENDER"] = "svc-enable-apple-pay-tender";
    FeatureNames["MOCK_MYATT"] = "svc-checkout-mock-myattapp";
    FeatureNames["APPLE_PAY_SUPPORTED_SUCCESS"] = "svc-enable-isapplesupported-success";
    FeatureNames["APPLE_PAY_SUPPORTED_SUCCESS_NO"] = "svc-enable-isapplesupported-sucess-negative";
    FeatureNames["INVOKE_APPLE_PAY_CANCEL"] = "svc-enable-invokeapplepay-cancel";
    FeatureNames["INVOKE_APPLE_PAY_DONE"] = "svc-enable-invokeapplepay-success";
    FeatureNames["COMBINED_TERMS"] = "svc-checkout-combined-terms";
    FeatureNames["APPLE_DEBUG_MODE"] = "svc-enable-appledebugmode";
})(FeatureNames = exports.FeatureNames || (exports.FeatureNames = {}));
//# sourceMappingURL=FeatureService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/FeatureService.js
// module id = 1438
// module chunks = 8